/* src/app/modules/shared/components/handle-badge-mode/handle-badge-mode.component.scss */
/*# sourceMappingURL=handle-badge-mode.component.css.map */
